var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-lg"},[_c('div',{staticClass:"circle",class:{ 'circle--online': _vm.online }})])}
var staticRenderFns = []

export { render, staticRenderFns }